// imports
// import componentIndex from './components/index'
import helperIndex from './helpers/index'
import interceptorIndex from './interceptors/index'
import pageIndex from './pages/index'
import serviceIndex from './services/index'

// export
export default {
	// components : componentIndex,
	helpers : helperIndex,
	interceptors : interceptorIndex,
	pages : pageIndex,
	services : serviceIndex
}

// export const components = componentIndex
export const helpers = helperIndex
export const interceptors = interceptorIndex 
export const pages = pageIndex
export const services = serviceIndex